import { ComboBox } from '@slal/ui/forms';
import { Col, Row, TBody } from '@slal/ui/layout';
import { Controller, useFormContext } from '@slal/ui/react-hook-form/core';
import { useFunds } from 'src/context';
import { Card, TD, TH, THead, TR, Table, useAnalytics } from '~/components';
import {
    formatDateToMonthYear,
    formatReportingPeriod,
    getMaximumAvailableReportingPeriod,
    getReportingPeriodOptions,
} from '~/utils';
import { InvestmentFundsViewProps } from '../types';
import { strings } from './strings';
import { StyledField } from './styles';

export const InvestmentFundsView = ({ maximumPeriod, setReportingPeriodYears }: InvestmentFundsViewProps) => {
    const { control } = useFormContext();
    const { selectedFunds } = useFunds();
    const { pushEvent } = useAnalytics();

    return (
        <Card>
            <Table>
                <THead>
                    <TR>
                        <TH>{strings.investmentFund}</TH>
                        <TH>{strings.fundInception}</TH>
                        <TH>{strings.availableData}</TH>
                    </TR>
                </THead>
                <TBody>
                    {selectedFunds.map(fund => (
                        <TR key={`${fund.name}-${fund.citicode}`}>
                            <TD>{fund.name}</TD>
                            <TD>{formatDateToMonthYear(fund.inceptionDate)}</TD>
                            <TD>{formatReportingPeriod(getMaximumAvailableReportingPeriod(fund.inceptionDate))}</TD>
                        </TR>
                    ))}
                </TBody>
            </Table>
            <Row>
                <Col col="12" md="6">
                    <StyledField label={strings.heading} labelFor="reportingPeriod" helpMessage={strings.description}>
                        <Controller
                            name="reportingPeriod"
                            control={control}
                            render={({ field }) => (
                                <ComboBox
                                    {...field}
                                    id="reportingPeriod"
                                    name="reportingPeriod"
                                    defaultValue={getReportingPeriodOptions(maximumPeriod)[0]}
                                    options={getReportingPeriodOptions(maximumPeriod)}
                                    onChange={option => {
                                        field.onChange(option);
                                        setReportingPeriodYears(Number(option?.value));
                                        pushEvent({
                                            eventCategory: 'Portfolio performance period',
                                            eventAction: 'Dropdown option selected',
                                            eventLabel: option?.label,
                                        });
                                    }}
                                />
                            )}
                        />
                    </StyledField>
                </Col>
            </Row>
        </Card>
    );
};
